"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Micro positioning-engine
 * @param el
 * @param reference
 * @param pos
 * @param padding
 * @returns {{update(): void}}
 * @constructor
 */
function Nanopop(_a) {
    var el = _a.el, reference = _a.reference, pos = _a.pos, _b = _a.padding, padding = _b === void 0 ? 8 : _b;
    var vBehaviour = { start: 'sme', middle: 'mse', end: 'ems' };
    var hBehaviour = { top: 'tb', right: 'rl', bottom: 'bt', left: 'lr' };
    var _c = pos.split('-'), position = _c[0], _d = _c[1], variant = _d === void 0 ? 'middle' : _d;
    var isVertical = (position === 'top' || position === 'bottom');
    return {
        update: function () {
            var rb = reference.getBoundingClientRect();
            var eb = el.getBoundingClientRect();
            var positions = isVertical ? {
                t: rb.top - eb.height - padding,
                b: rb.bottom + padding
            } : {
                r: rb.right + padding,
                l: rb.left - eb.width - padding
            };
            var variants = isVertical ? {
                s: rb.left + rb.width - eb.width,
                m: (-eb.width / 2) + (rb.left + rb.width / 2),
                e: rb.left
            } : {
                s: rb.bottom - eb.height,
                m: rb.bottom - rb.height / 2 - eb.height / 2,
                e: rb.bottom - rb.height
            };
            function apply(bevs, vars, styleprop) {
                var vertical = styleprop === 'top';
                var adder = vertical ? eb.height : eb.width;
                var win = window[vertical ? 'innerHeight' : 'innerWidth'];
                for (var _i = 0, bevs_1 = bevs; _i < bevs_1.length; _i++) {
                    var ch = bevs_1[_i];
                    var v = vars[ch];
                    if (v > 0 && (v + adder) < win) {
                        el.style[styleprop] = v + "px";
                        break;
                    }
                }
            }
            apply(vBehaviour[variant], variants, isVertical ? 'left' : 'top');
            apply(hBehaviour[position], positions, isVertical ? 'top' : 'left');
        }
    };
}
exports.default = Nanopop;
